const allowedOriginsEnv: string = import.meta.env['VITE_ALLOWED_DASHBOARD_ORIGINS'] ?? '';

export const allowedDashboardOrigins = new Set(
	allowedOriginsEnv.split(',').map((origin) => origin.trim()),
);
